"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("./index");
var _useFoxModalFullScreenProps = _interopRequireDefault(require("./variant/useFoxModalFullScreenProps"));
function FoxModalFullScreen(rest) {
  return /*#__PURE__*/_react["default"].createElement(_index.Modal, (0, _useFoxModalFullScreenProps["default"])(rest));
}
var _default = exports["default"] = FoxModalFullScreen;